export const CREATIVE_UPDATE_STATUS = {
  ALL_CAN_UPDATE: "all_can_update",
  ALL_NOT_CAN_UPDATE: "all_not_can_update",
  MIX_CAN_UPDATE: "mix_can_update",
  MIX_NOT_CAN_UPDATE: "mix_not_can_update",
};
